module.exports = __webpack_public_path__ + "img/room-2.96fc8c63.jpg";